import { Injectable, Injector, computed, signal } from '@angular/core';
import { GetPeriodicSmartSmsRequestByIdDto } from '../api/models';

@Injectable({
  providedIn: 'root',
})
export class SmartSmsShareMemoryService {
  dollarPrice: number;

  #smartSmsRequestId = signal<number>(0);
  #smartSmsRequestTitle = signal<string>('');
  #periodicSmartSmsModel = signal<GetPeriodicSmartSmsRequestByIdDto>(null);
  #smartSmsIsPeriodic = signal<boolean>(false);

  smartSmsRequestId = computed(this.#smartSmsRequestId);
  smartSmsRequestTitle = computed(this.#smartSmsRequestTitle);
  periodicSmartSmsModel = computed(this.#periodicSmartSmsModel);
  smartSmsIsPeriodic = computed(this.#smartSmsIsPeriodic);

  constructor(private injector: Injector) {}

  setIsPeriodic(value: boolean) {
    this.#smartSmsIsPeriodic.set(value);
  }

  getIsPeriodic(): boolean {
    return this.smartSmsIsPeriodic();
  }

  setScheduledMessageId(id: number) {
    this.#smartSmsRequestId.set(id);
  }

  getScheduledMessageId(): number {
    return this.smartSmsRequestId();
  }

  setScheduledMessageTitle(title: string) {
    this.#smartSmsRequestTitle.set(title);
  }

  getScheduledMessageTitle(): string {
    return this.smartSmsRequestTitle();
  }

  setUpdatePeriodicSmartSmsModel(model: GetPeriodicSmartSmsRequestByIdDto) {
    this.#periodicSmartSmsModel.set(model);
  }

  getUpdatePeriodicSmartSmsModel(): GetPeriodicSmartSmsRequestByIdDto {
    return this.periodicSmartSmsModel();
  }
}
